"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
const danger = '#d70b0b';
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'enterprise',
    userFriendlyName: 'Enterprise',
    space: [0, 1, 2, 3, 4, 5, 6],
    breakpoints: ['40em', '52em', '64em', '80em', '100em'],
    fontImports: [],
    fonts: {
        heading: "'Times New Roman', serif",
        subheading: "'Times New Roman', serif",
        body: "'Times New Roman', serif",
        navigation: "'Times New Roman', serif",
    },
    dark: false,
    shadows: [
        '5px 5px 16px rgba(125,125,125,0.0625)',
        '5px 5px 16px rgba(125,125,125,0.12)',
        '5px 5px 16px rgba(125,125,125,0.25)',
        '5px 5px 16px rgba(125,125,125,0.5)',
        '5px 5px 16px rgba(125,125,125,1)',
    ],
    colors: {
        primary: '#fff',
        primaryText: '#000',
        primaryDark: '#000',
        danger,
        muted: '#eee',
        success: '#0f0',
        offline: danger,
        info: '#00f',
        warning: '#ff0',
        online: '#0f0',
        accent: '#980',
        accentBackgroundedText: '#FFF',
        pageBackground: '#fff',
        pageText: '#000',
        cardBackground: '#fff',
        cardText: '#000',
        selected: '#00f',
        install: {
            connected: '#0f0',
            expired: '#f00',
            pending: '#00f',
            planned: '#ccc',
            skipped: '#ff0',
        },
        floorplans: lifeCycle_1.theme.colors.floorplans,
        charts: {
            primary: '#000',
            min: '#00f',
            neutral: '#999',
            max: '#f00',
            intervalShade: '#ddd',
        },
    },
});
//# sourceMappingURL=index.js.map